// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Activity Logs — scoped layout (matches profile activity table design) */
.agce-activity-logs-wrap .cnt.agce-activity-logs {
  max-width: 100%;
}

.agce-activity-logs__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
  flex-wrap: wrap;
}

.agce-activity-logs__title {
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.02em;
  margin: 0 0 8px;
  line-height: 1.2;
}

.agce-activity-logs__sub {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  color: #94a3b8;
  line-height: 1.5;
  max-width: 520px;
}

.agce-activity-logs__export {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #dfdfdf;
  background: #ffffff1c;
  border: 1px solid #e9eaef17;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
}

body.light_theme .agce-activity-logs__export {
  color: #101828;
  background: #ffffff;
  border: 1px solid #E9EAEF;
}

.agce-activity-logs__export:hover {
  opacity: 0.9;
}

.agce-activity-logs__export i {
  font-size: 18px;
  color: #64748b;
}

.agce-activity-logs__tablewrap {
  width: 100%;
}

.agce-activity-logs-wrap.activity_logs .agce-activity-logs__table {
  margin-top: 0;
}

.agce-activity-logs__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.agce-activity-logs__table thead th,
.agce-activity-logs__table tbody td {
  text-align: left;
}

.agce-activity-logs__table thead th {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  padding: 7px 10px;
  text-transform: none;
  letter-spacing: 0.02em;
  border-bottom: 1px solid #f1f5f914;
}

body.light_theme .agce-activity-logs__table thead th {
  border-bottom: 1px solid #f1f5f9;
}

.agce-activity-logs__table tbody tr {
  border-bottom: 1px solid #f1f5f914;
}

body.light_theme .agce-activity-logs__table tbody tr {
  border-bottom: 1px solid #f1f5f9;
}

.agce-activity-logs__table tbody tr:last-child {
  border-bottom: none;
}

.agce-activity-logs__table tbody td {
  padding: 14px 10px;
  vertical-align: middle;
  color: #eaeaea;
  font-weight: 500;
}

body.light_theme .agce-activity-logs__table tbody td {
  color: #64748b;
}

.agce-activity-logs__table tbody td.agce-activity-logs__col-desc {
  color: #dfdfdf;
  font-weight: 400;
}

body.light_theme .agce-activity-logs__table tbody td.agce-activity-logs__col-desc {
  color: #64748b;
}

.agce-activity-logs__table tbody td.agce-activity-logs__col-time {
  color: #00A63E;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
}

.agce-activity-logs__activity-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agce-activity-logs__act-badge {
  width: 26px;
  height: 26px;
  border-radius: 10px;
  /* background: #00A63E; */
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.agce-activity-logs__act-badge i {
  font-size: 18px;
}

.agce-activity-logs__activity-cell strong {
  font-size: 14px;
  font-weight: 500;
  color: #efefef;
}

body.light_theme .agce-activity-logs__activity-cell strong {
  color: #1e293b;
}

/* Mobile cards */
.agce-activity-logs__cards {
  list-style: none;
  margin: 0;
  padding: 0;
  display: none;
  flex-direction: column;
  gap: 12px;
}

.agce-activity-logs__card {
  background: #ffffff0f;
  border: 1px solid #eef2f717;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

body.light_theme .agce-activity-logs__card {
  background: #ffffff;
  border: 1px solid #eef2f7;
}

.agce-activity-logs__card-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f914;
  font-size: 14px;
}

body.light_theme .agce-activity-logs__card-row {
  border-bottom: 1px solid #f1f5f9;
}

.agce-activity-logs__card-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.agce-activity-logs__card-label {
  color: #94a3b8;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

.agce-activity-logs__card-val {
  color: #dbdbdb;
  text-align: right;
  font-weight: 500;
}

body.light_theme .agce-activity-logs__card-val {
  color: #475569;
}

.agce-activity-logs__card-val--time {
  color: #2d9d5e;
  font-weight: 600;
}

.agce-activity-logs__card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.agce-activity-logs__card-head strong {
  font-size: 15px;
  color: #ececec;
}

body.light_theme .agce-activity-logs__card-head strong {
  color: #1e293b;
}

@media (max-width: 991.98px) {
  .agce-activity-logs__tablewrap--desktop {
    display: none;
  }

  .agce-activity-logs__cards {
    display: flex;
  }

  .agce-activity-logs__title {
    font-size: 22px;
  }

  .agce-activity-logs__head {
    gap: 10px;
  }

  .agce-activity-logs__head {
    margin-bottom: 20px;
  }

  .agce-activity-logs__export {
    justify-content: center;
  }
}

@media (min-width: 992px) {
  .agce-activity-logs__cards {
    display: none !important;
  }
}

@media (max-width: 767px) {

  .agce-activity-logs__card-row {
    font-size: 12px;
  }

  .agce-activity-logs__card-val {
    word-break: break-word;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ActivitylogPage/activityLogs.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;AAEF","sourcesContent":["/* Activity Logs — scoped layout (matches profile activity table design) */\n.agce-activity-logs-wrap .cnt.agce-activity-logs {\n  max-width: 100%;\n}\n\n.agce-activity-logs__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 28px;\n  flex-wrap: wrap;\n}\n\n.agce-activity-logs__title {\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  margin: 0 0 8px;\n  line-height: 1.2;\n}\n\n.agce-activity-logs__sub {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  color: #94a3b8;\n  line-height: 1.5;\n  max-width: 520px;\n}\n\n.agce-activity-logs__export {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #dfdfdf;\n  background: #ffffff1c;\n  border: 1px solid #e9eaef17;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  flex-shrink: 0;\n}\n\nbody.light_theme .agce-activity-logs__export {\n  color: #101828;\n  background: #ffffff;\n  border: 1px solid #E9EAEF;\n}\n\n.agce-activity-logs__export:hover {\n  opacity: 0.9;\n}\n\n.agce-activity-logs__export i {\n  font-size: 18px;\n  color: #64748b;\n}\n\n.agce-activity-logs__tablewrap {\n  width: 100%;\n}\n\n.agce-activity-logs-wrap.activity_logs .agce-activity-logs__table {\n  margin-top: 0;\n}\n\n.agce-activity-logs__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.agce-activity-logs__table thead th,\n.agce-activity-logs__table tbody td {\n  text-align: left;\n}\n\n.agce-activity-logs__table thead th {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n  padding: 7px 10px;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  border-bottom: 1px solid #f1f5f914;\n}\n\nbody.light_theme .agce-activity-logs__table thead th {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.agce-activity-logs__table tbody tr {\n  border-bottom: 1px solid #f1f5f914;\n}\n\nbody.light_theme .agce-activity-logs__table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.agce-activity-logs__table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.agce-activity-logs__table tbody td {\n  padding: 14px 10px;\n  vertical-align: middle;\n  color: #eaeaea;\n  font-weight: 500;\n}\n\nbody.light_theme .agce-activity-logs__table tbody td {\n  color: #64748b;\n}\n\n.agce-activity-logs__table tbody td.agce-activity-logs__col-desc {\n  color: #dfdfdf;\n  font-weight: 400;\n}\n\nbody.light_theme .agce-activity-logs__table tbody td.agce-activity-logs__col-desc {\n  color: #64748b;\n}\n\n.agce-activity-logs__table tbody td.agce-activity-logs__col-time {\n  color: #00A63E;\n  font-weight: 500;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.agce-activity-logs__activity-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.agce-activity-logs__act-badge {\n  width: 26px;\n  height: 26px;\n  border-radius: 10px;\n  /* background: #00A63E; */\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.agce-activity-logs__act-badge i {\n  font-size: 18px;\n}\n\n.agce-activity-logs__activity-cell strong {\n  font-size: 14px;\n  font-weight: 500;\n  color: #efefef;\n}\n\nbody.light_theme .agce-activity-logs__activity-cell strong {\n  color: #1e293b;\n}\n\n/* Mobile cards */\n.agce-activity-logs__cards {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: none;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.agce-activity-logs__card {\n  background: #ffffff0f;\n  border: 1px solid #eef2f717;\n  border-radius: 12px;\n  padding: 16px 18px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\nbody.light_theme .agce-activity-logs__card {\n  background: #ffffff;\n  border: 1px solid #eef2f7;\n}\n\n.agce-activity-logs__card-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid #f1f5f914;\n  font-size: 14px;\n}\n\nbody.light_theme .agce-activity-logs__card-row {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.agce-activity-logs__card-row:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.agce-activity-logs__card-label {\n  color: #94a3b8;\n  font-weight: 600;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.agce-activity-logs__card-val {\n  color: #dbdbdb;\n  text-align: right;\n  font-weight: 500;\n}\n\nbody.light_theme .agce-activity-logs__card-val {\n  color: #475569;\n}\n\n.agce-activity-logs__card-val--time {\n  color: #2d9d5e;\n  font-weight: 600;\n}\n\n.agce-activity-logs__card-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.agce-activity-logs__card-head strong {\n  font-size: 15px;\n  color: #ececec;\n}\n\nbody.light_theme .agce-activity-logs__card-head strong {\n  color: #1e293b;\n}\n\n@media (max-width: 991.98px) {\n  .agce-activity-logs__tablewrap--desktop {\n    display: none;\n  }\n\n  .agce-activity-logs__cards {\n    display: flex;\n  }\n\n  .agce-activity-logs__title {\n    font-size: 22px;\n  }\n\n  .agce-activity-logs__head {\n    gap: 10px;\n  }\n\n  .agce-activity-logs__head {\n    margin-bottom: 20px;\n  }\n\n  .agce-activity-logs__export {\n    justify-content: center;\n  }\n}\n\n@media (min-width: 992px) {\n  .agce-activity-logs__cards {\n    display: none !important;\n  }\n}\n\n@media (max-width: 767px) {\n\n  .agce-activity-logs__card-row {\n    font-size: 12px;\n  }\n\n  .agce-activity-logs__card-val {\n    word-break: break-word;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
